<template>
    <div class="login">
        <div class="login__left">
            <img :src="base_url + '/admin/img/logo-alternate.svg'" />
        </div>
        <div class="login__right">
            <div class="login-card">
                <h1>Login to <span class="text-primary">Tawajud</span></h1>
                <p>Enter your login details below</p>
                <form action="#" id="loginForm" @submit.prevent="submitLogin">
                    <div class="form-group">
                        <label for="">Email</label>
                        <input type="email" name="email" class="form-control" v-model="loginForm.email" required />
                    </div>
                    <div class="form-group position-relative">
                        <label for="">Password</label>
                        <input type="password" name="password" class="form-control" v-model="loginForm.password" required />
                        <small class="mt-2 d-block"> <a href="#" data-bs-toggle="modal" data-bs-target="#forgotPasswordModal">Forgot Password ? </a> </small>
                        <button type="button" class="btn password">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0)">
                                    <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke="#4F4F4F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <path
                                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                                        stroke="#4F4F4F"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></path>
                                    <path data-password="false" d="M22.4906 2L23.5864 3.26254L1.09581 22.783L0 21.5205L22.4906 2Z" fill="#4F4F4F"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0">
                                        <rect width="24" height="24" fill="white" transform="translate(24 24.1147) rotate(-180)"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                    <p class="text-danger">{{ error_message }}</p>
                    <input class="btn btn-primary mt-5" type="submit" value="Login" />
                </form>
            </div>
        </div>

        <!-- Forgot Password Modal -->
        <div class="modal fade" id="forgotPasswordModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form action="" @submit.prevent="forgetPassword">
                        <div class="modal-body">
                            <div class="feature-block">
                                <img :src="base_url + '/admin/img/forgotPassword.svg'" />
                                <h4>Forgot Password</h4>
                                <p>To Reset password, kindly enter your registered email below</p>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" v-model="forgetPasswordForm.email" placeholder="Enter your email address" />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Reset Password</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error_message: "",
            loginForm: new Form({
                email: '', password: '',admin:true
            }),
            forgetPasswordForm: new Form({
                email: ''
            })
        }
    },
    methods: {
        submitLogin: function() {
            axios({
                method: "post",
                url: "/api/admin/login",
                data: this.loginForm
            }).then((response) => {
                if(response.data.status) {
                    this.$root.adminLogin(response.data.data);
                    window.location.href = "/dashboard";
                } else {
                    this.error_message = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        },
        forgetPassword: function() {
            axios({
                method: "post",
                url: "/api/admin/forget-password",
                data: this.forgetPasswordForm
            }).then((response) => {
                if(response.data.status) {
                    $("#forgotPasswordModal").modal("hide");
                    Toast.fire({icon: 'success', title: response.data.message});
                } else {
                    this.error_message = response.data.message;
                    Toast.fire({icon: 'error', title: response.data.message});
                }
            }, (error) => {
                console.log(error)
            });
        }
    },
}
</script>